export const slideDirections = {
  BACKWARD: 'backward',
  FORWARD: 'forward'
};
//# sourceMappingURL=slideDirections.js.map